import type {
  ClientAdminsStressAssessmentAnswer,
  StressAssessmentCategory,
} from '@fukuri-admins/apis/client/gen/model';
import type { StressAssessmentAnswerTablePresentation } from '../presentations';

type PresentationProps = React.ComponentProps<typeof StressAssessmentAnswerTablePresentation>;
type AnswersByCategory = PresentationProps['answersByCategory'];

/**
 * 回答をカテゴリーごとにグループ化する
 */
export const convertAnswersByCategory = (
  answers: ClientAdminsStressAssessmentAnswer[]
): AnswersByCategory => {
  return answers.reduce((acc, answer) => {
    const category = answer.stress_assessment_question.category;

    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(answer);
    return acc;
  }, {} as AnswersByCategory);
};

/**
 * カテゴリー配列からカテゴリー名→ラベルのマップを作成する
 */
export const createCategoryTitleMap = (
  categories?: StressAssessmentCategory[]
): Record<string, string> => {
  return (
    categories?.reduce(
      (acc, cat) => {
        acc[cat.name] = cat.label;
        return acc;
      },
      {} as Record<string, string>
    ) ?? {}
  );
};
